import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const ProtectedRouteMember = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [hasMemberRole, setHasMemberRole] = useState(null);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const role = userSnap.data().role;
            setHasMemberRole(role === 'member');
          } else {
            setHasMemberRole(false);
          }
          setIsAuthenticated(true);
        } catch (error) {
          console.error('Error fetching user role:', error);
          setHasMemberRole(false);
          setIsAuthenticated(true);
        }
      } else {
        setIsAuthenticated(false);
      }
    });

    return () => unsubscribe();
  }, [auth, db]);

  if (isAuthenticated === null || hasMemberRole === null) {
    return (
      <div className="spinner-container">
        <div className="custom-spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated || !hasMemberRole) {
    return <Navigate to="/member-login" replace />;
  }

  return children;
};

export default ProtectedRouteMember;